import Vue from 'vue';
import Moment from "moment";

Vue.filter('initials', function (value, length = 0) {
    let initials = value.getInitials();
    if (!initials) {
        return "N/A";
    }

    if (length) {
        return initials.substr(0, length);
    }

    return initials;
});

Vue.filter('accurateTimeAgo', function (value) {
    if (!value) {
        return 'never';
    }

    if (Moment().diff(Moment(value), 'months', true) >= 1) {
        return Moment(value).format('MM/DD/YYYY');
    }

    return Moment(value).fromNow();
});
